import * as React from "react";
import { SVGProps, memo } from "react";

const SvgSearchPharmacy = (props: SVGProps<SVGSVGElement>) => (
  <svg width={80} height={80} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={40} cy={40} r={40} fill="#D5E8DE" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.758 38.254a6.823 6.823 0 0 1-4.265 1.479c-3.703 0-6.704-2.898-6.704-6.473 0-3.574 3.002-6.472 6.704-6.472s6.703 2.898 6.703 6.472a6.304 6.304 0 0 1-1.406 3.968l3.691 3.564c.29.279.29.731 0 1.01a.76.76 0 0 1-1.047 0l-3.676-3.548Zm.947-4.994c0 2.78-2.334 5.033-5.212 5.033-2.879 0-5.212-2.253-5.212-5.033 0-2.779 2.333-5.032 5.212-5.032 2.878 0 5.212 2.253 5.212 5.032Z"
      fill="#637182"
    />

    <path
      d="M13.993 27.166h32.022v6.953H13.993v-6.953ZM13.993 36.455h32.022v20.912H13.993V36.455Z"
      fill="#fff"
    />

    <path d="M12.8 34.132h34.4v2.323H12.8v-2.323Z" fill="#58C6E3" />

    <path d="M32.968 40.522h8.894v16.845h-8.894V40.522Z" fill="#7CDEDF" />

    <path d="M18.139 49.24h10.648v2.906H18.139V49.24Z" fill="#3BBDDF" />

    <path d="M19.296 40.522h8.306v8.718h-8.306v-8.718Z" fill="#7ADEDE" />

    <path
      d="M39.492 48.656a.61.61 0 0 1-.42-.173.586.586 0 0 1-.177-.411v-.584a.578.578 0 0 1 .178-.409.603.603 0 0 1 .835 0c.11.109.173.256.173.409v.584a.578.578 0 0 1-.172.41.603.603 0 0 1-.417.174Z"
      fill="#195C85"
    />

    <path
      d="M21.702 45.166a.598.598 0 0 1-.332-.093.567.567 0 0 1-.094-.894l1.782-1.745a.599.599 0 0 1 .838 0 .574.574 0 0 1 0 .82l-1.76 1.745a.583.583 0 0 1-.434.167ZM22.292 47.488a.598.598 0 0 1-.33-.096.566.566 0 0 1-.09-.891l2.968-2.907a.598.598 0 0 1 .838 0 .574.574 0 0 1 0 .82l-2.967 2.907a.584.584 0 0 1-.42.167Z"
      fill="#fff"
    />

    <path
      d="M30 30.81c3.725 0 6.744-2.958 6.744-6.605 0-3.648-3.019-6.605-6.744-6.605-3.724 0-6.743 2.957-6.743 6.605 0 3.647 3.02 6.604 6.743 6.604Z"
      fill="#7ADEDE"
    />

    <path
      d="M33.295 21.347a1.959 1.959 0 0 0-1.367-.552c-.512 0-1.003.199-1.366.552l-1.42 1.39.802 1.266-.078.063.206.146.114.173.064-.062 1.618 1.084 1.42-1.39c.361-.354.565-.833.566-1.334.002-.5-.2-.98-.56-1.336Z"
      fill="#fff"
    />

    <path
      d="m30.512 24.066-1.363-1.335-1.023 1.001-1.42 1.39a1.892 1.892 0 0 0-.443.614 1.857 1.857 0 0 0 .4 2.1 1.968 1.968 0 0 0 2.143.396 1.93 1.93 0 0 0 .627-.433l1.42-1.39 1.021-1.002-1.362-1.341Z"
      fill="#E5356E"
    />
  </svg>
);

const Memo = memo(SvgSearchPharmacy);

export default Memo;
